import get from 'lodash/get'

const grabColor =
  (color) =>
  ({ theme }) =>
    get(theme.colors, color, '')

export default grabColor
